import Vue from 'vue'
import VueCookie from 'vue-cookie'

Vue.use(VueCookie)

// Cookie keys

const USER_KEY = '_user'
const ACCESS_TOKEN_KEY = '_accessToken'
const REFRESH_TOKEN_KEY = '_refreshToken'
const DATATABLE_INFOS_KEY = '_datatableInfos'
const NOTIFICATION_INFOS_KEY = '_notificationInfos'
const TAB_INFOS_KEY = '_tabInfos'
const TOGGLE_SIDEBAR_KEY = '_toggleSidebar'

// Authentication

export function getUser () {
  return VueCookie.get(USER_KEY)
}

export function getRefreshToken () {
  return VueCookie.get(REFRESH_TOKEN_KEY)
}

export function getAccessToken () {
  return VueCookie.get(ACCESS_TOKEN_KEY)
}

export function setUser (user) {
  VueCookie.set(USER_KEY, user)
}

export function setAccessToken (token) {
  VueCookie.set(ACCESS_TOKEN_KEY, token)
}

export function setRefreshToken (token) {
  VueCookie.set(REFRESH_TOKEN_KEY, token)
}

export function clearCredentials () {
  VueCookie.delete(USER_KEY)
  VueCookie.delete(ACCESS_TOKEN_KEY)
  VueCookie.delete(REFRESH_TOKEN_KEY)
  VueCookie.delete(DATATABLE_INFOS_KEY)
  VueCookie.delete(TAB_INFOS_KEY)
}

// Dictionary Common

function getDictionary (cookieKey) {
  var dictStr = VueCookie.get(cookieKey)

  if (dictStr == null) {
    dictStr = JSON.stringify({})
    VueCookie.set(cookieKey, dictStr)
  }

  var dict = JSON.parse(dictStr)
  return dict
}

function getDictionaryValue (cookieKey, dictKey) {
  var dict = getDictionary(cookieKey)
  return dictKey in dict ? dict[dictKey] : null
}

function setDictionaryValue (cookieKey, dictKey, dictValue) {
  var dict = getDictionary(cookieKey)
  dict[dictKey] = dictValue
  var dictStr = JSON.stringify(dict)
  VueCookie.set(cookieKey, dictStr)
}

// Datatables

export function getDatatableInfo (key) {
  return getDictionaryValue(DATATABLE_INFOS_KEY, key)
}

export function setDatatableInfo (key, info) {
  setDictionaryValue(DATATABLE_INFOS_KEY, key, info)
}

// Notifications

export function getNotificationInfo (key) {
  return getDictionaryValue(NOTIFICATION_INFOS_KEY, key)
}

export function setNotificationInfo (key, info) {
  setDictionaryValue(NOTIFICATION_INFOS_KEY, key, info)
}

// Tabs

export function getTabsInfo (key) {
  return getDictionaryValue(TAB_INFOS_KEY, key)
}

export function setTabsInfo (key, info) {
  setDictionaryValue(TAB_INFOS_KEY, key, info)
}

// Sidebar collapse toggle

export function getSidebarToggleInfo (key) {
  return getDictionaryValue(TOGGLE_SIDEBAR_KEY, key)
}

export function setSidebarToggleInfo (key, info) {
  setDictionaryValue(TOGGLE_SIDEBAR_KEY, key, info)
}
